import { useIntl } from 'react-intl';

export default function extraTranslationsDefinition() {
  const intl = useIntl();
  intl.formatMessage({ id: 'My tour', defaultMessage: 'My tour' });
  intl.formatMessage({ id: 'Friends tour', defaultMessage: 'Friends tour' });
  intl.formatMessage({ id: 'Dreamtours', defaultMessage: 'Dreamtours' });
  intl.formatMessage({ id: 'Track', defaultMessage: 'Track' });
  intl.formatMessage({ id: 'Create a tour', defaultMessage: 'Create a tour' });
  intl.formatMessage({ id: 'My Bike Clubs', defaultMessage: 'My Bike Clubs' });
  intl.formatMessage({
    id: 'Create a Bike Club',
    defaultMessage: 'Create a Bike Club',
  });
  intl.formatMessage({ id: 'My BikerBeds', defaultMessage: 'My BikerBeds' });
  intl.formatMessage({
    id: 'Create a BikerBed',
    defaultMessage: 'Create a BikerBed',
  });
  intl.formatMessage({ id: 'FAQ', defaultMessage: 'FAQ' });
  intl.formatMessage({ id: 'Saved', defaultMessage: 'Saved' });
  intl.formatMessage({ id: 'Friend tours', defaultMessage: 'Friend tours' });

  intl.formatMessage({ id: 'Unlimited', defaultMessage: 'Unlimited' });
  intl.formatMessage({ id: 'Paid feature', defaultMessage: 'Paid feature' });
  intl.formatMessage({
    id: 'Cloud based route planning',
    defaultMessage: 'Cloud based route planning',
  });
  intl.formatMessage({
    id: 'Ride tour with friends',
    defaultMessage: 'Ride tour with friends',
  });
  intl.formatMessage({
    id: 'Get link of tour',
    defaultMessage: 'Get link of tour',
  });
  intl.formatMessage({
    id: 'Embed Tour and RidePlan',
    defaultMessage: 'Embed Tour and RidePlan',
  });
  intl.formatMessage({
    id: 'Create private tour',
    defaultMessage: 'Create private tour',
  });
  intl.formatMessage({
    id: 'Create public tour',
    defaultMessage: 'Create public tour',
  });
  intl.formatMessage({
    id: 'Download PDF of Tour',
    defaultMessage: 'Download PDF of Tour',
  });
  intl.formatMessage({
    id: 'Print actual/detailed map view',
    defaultMessage: 'Print actual/detailed map view',
  });
  intl.formatMessage({
    id: 'Full map view option',
    defaultMessage: 'Full map view option',
  });
  intl.formatMessage({
    id: 'Time between points on tour',
    defaultMessage: 'Time between points on tour',
  });
  intl.formatMessage({
    id: 'Use home position as start of the tour',
    defaultMessage: 'Use home position as start of the tour',
  });
  intl.formatMessage({
    id: 'Use home position as end of the tour',
    defaultMessage: 'Use home position as end of the tour',
  });
  intl.formatMessage({
    id: 'Bookmark tour and add to “My Page”',
    defaultMessage: 'Bookmark tour and add to “My Page”',
  });
  intl.formatMessage({
    id: 'Plan tour in RidePlan',
    defaultMessage: 'Plan tour in RidePlan',
  });
  intl.formatMessage({
    id: 'Download tour gps data',
    defaultMessage: 'Download tour gps data',
  });
  intl.formatMessage({
    id: 'Navigation in Android',
    defaultMessage: 'Navigation in Android',
  });
  intl.formatMessage({
    id: 'Navigation in iPhone',
    defaultMessage: 'Navigation in iPhone',
  });
  intl.formatMessage({ id: 'kilometers', defaultMessage: 'kilometers' });
  intl.formatMessage({ id: 'miles', defaultMessage: 'miles' });
  intl.formatMessage({
    id: 'Wrong login or password',
    defaultMessage: 'Wrong login or password',
  });
  return '';
}
